var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ul", { staticClass: "pagination u-list-inline" }, [
    _c(
      "li",
      { staticClass: "pagination__item pagination__item--prev" },
      [
        _c("icon-button", {
          attrs: {
            label: "Previous Page",
            icon: "chevron-left",
            size: "16px",
            disabled: _vm.currentPage === 1,
          },
          on: { click: _vm.previousPage },
        }),
      ],
      1
    ),
    _c(
      "li",
      { staticClass: "pagination__item" },
      _vm._l(_vm.totalPages, function (page) {
        return _c(
          "a",
          {
            key: page,
            staticClass: "pagination__link",
            class: { "pagination__link--active": _vm.currentPage === page },
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.setPage(page)
              },
              keypress: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                $event.preventDefault()
                return _vm.setPage(page)
              },
            },
          },
          [
            _c("span", { staticClass: "u-sr-only" }, [_vm._v("page")]),
            _vm._v(_vm._s(page)),
          ]
        )
      }),
      0
    ),
    _c(
      "li",
      { staticClass: "pagination__item pagination__item--next" },
      [
        _c("icon-button", {
          attrs: {
            label: "Next Page",
            icon: "chevron-right",
            size: "16px",
            disabled: _vm.currentPage === _vm.totalPages,
          },
          on: { click: _vm.nextPage },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }